module.exports = __webpack_public_path__ + "img/font_script-mt-bold.cd7fa52.svg";